/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { PopupConfigInfoRespVo } from './PopupConfigInfoRespVo';
import {
    PopupConfigInfoRespVoFromJSON,
    PopupConfigInfoRespVoFromJSONTyped,
    PopupConfigInfoRespVoToJSON,
    PopupConfigInfoRespVoToJSONTyped,
} from './PopupConfigInfoRespVo';

/**
 * 
 * @export
 * @interface ResponsePopupConfigInfoRespVo
 */
export interface ResponsePopupConfigInfoRespVo {
    /**
     * 接口状态码
     * @type {number}
     * @memberof ResponsePopupConfigInfoRespVo
     */
    code?: number;
    /**
     * 接口返回消息
     * @type {string}
     * @memberof ResponsePopupConfigInfoRespVo
     */
    message?: string;
    /**
     * 
     * @type {PopupConfigInfoRespVo}
     * @memberof ResponsePopupConfigInfoRespVo
     */
    data?: PopupConfigInfoRespVo;
}

/**
 * Check if a given object implements the ResponsePopupConfigInfoRespVo interface.
 */
export function instanceOfResponsePopupConfigInfoRespVo(value: object): value is ResponsePopupConfigInfoRespVo {
    return true;
}

export function ResponsePopupConfigInfoRespVoFromJSON(json: any): ResponsePopupConfigInfoRespVo {
    return ResponsePopupConfigInfoRespVoFromJSONTyped(json, false);
}

export function ResponsePopupConfigInfoRespVoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ResponsePopupConfigInfoRespVo {
    if (json == null) {
        return json;
    }
    return {
        
        'code': json['code'] == null ? undefined : json['code'],
        'message': json['message'] == null ? undefined : json['message'],
        'data': json['data'] == null ? undefined : PopupConfigInfoRespVoFromJSON(json['data']),
    };
}

export function ResponsePopupConfigInfoRespVoToJSON(json: any): ResponsePopupConfigInfoRespVo {
    return ResponsePopupConfigInfoRespVoToJSONTyped(json, false);
}

export function ResponsePopupConfigInfoRespVoToJSONTyped(value?: ResponsePopupConfigInfoRespVo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'code': value['code'],
        'message': value['message'],
        'data': PopupConfigInfoRespVoToJSON(value['data']),
    };
}

